import { render, staticRenderFns } from "./posterSet.vue?vue&type=template&id=64cd18fc&"
import script from "./posterSet.vue?vue&type=script&lang=js&"
export * from "./posterSet.vue?vue&type=script&lang=js&"
import style0 from "./posterSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports